import React from 'react';
import { Container, Grid, Typography, Button, IconButton, CircularProgress } from '@mui/material';
import Page from 'src/components/Page';
import { useNavigate } from 'react-router-dom';

import { HiPlusCircle } from 'react-icons/hi2';
import { IoArrowForward } from 'react-icons/io5';
import { GoClock } from 'react-icons/go';
import { CiClock2 } from 'react-icons/ci';
import { StudentsIcon } from 'src/images/svg';
import palette from 'src/theme/palette';

import '../../styles/classes.css';
import 'react-toastify/dist/ReactToastify.css';
import { useQuery } from '@tanstack/react-query';
import { classService } from 'src/services/class.service';
import { useAuth } from 'src/context/auth/AuthContext';

export default function Classes() {
  const navigate = useNavigate();

  const { user: currentUser, hasPermission } = useAuth();
  const teacherUserId = hasPermission('classes.view_all') ? undefined : currentUser?.id;

  // Fetch classes
  const {
    data: classes,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['classes', { teacherUserId }],
    queryFn: () => classService.getClasses({ teacherUserId }),
  });

  // if (isLoading) return <div>Loading...</div>;
  // if (error) return <div>Failed to load classes</div>;
  console.log(classes);
  return (
    <Page title="Users">
      <Container maxWidth={false} sx={{ px: 1 }}>
        {isLoading ? (
          <Grid container justifyContent={'center'} mt={10} mb={10}>
            <CircularProgress />
          </Grid>
        ) : (
          <Grid container spacing={2}>
            {classes?.data?.map((val, i) => {
              return (
                <Grid key={i} item sm={12} xs={12} md={4} lg={3} xl={3}>
                  <div className="classCard">
                    <Typography variant="h3" color={palette.common.white}>
                      {val.name}
                    </Typography>
                    <div className="timings">
                      <CiClock2 color={palette.common.white} size={20} />
                      <Typography color={palette.common.white}>
                        {val.starttime}-{val.endtime}
                      </Typography>
                    </div>
                    <div className="timings">
                      <StudentsIcon color={palette.common.white} />
                      <Typography color={palette.common.white}>{val?.enrolledStudents.length} Students</Typography>
                    </div>

                    <Button
                      fullWidth
                      style={{ backgroundColor: palette.secondary.main, height: 50, marginTop: 15 }}
                      variant="contained"
                      onClick={() =>
                        navigate('/teacher/enrolled-students/' + val.id, {
                          state: { enrolledStudents: val.enrolledStudents },
                        })
                      }
                    >
                      Enter Class <IoArrowForward style={{ marginLeft: 5 }} size={20} />
                    </Button>
                    <Button
                      fullWidth
                      style={{ backgroundColor: palette.secondary.main, height: 50, marginTop: 15 }}
                      variant="contained"
                      onClick={() => navigate('/teacher/add-students/' + val.id)}
                    >
                      Manage Students <IoArrowForward style={{ marginLeft: 5 }} size={20} />
                    </Button>
                  </div>
                </Grid>
              );
            })}

            {hasPermission('classes.create') && (
              <Grid item sm={12} xs={12} md={4} lg={3} xl={3}>
                <div
                  className="classCard"
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}
                >
                  <IconButton onClick={() => navigate('/admin/add-new-class')}>
                    <HiPlusCircle color={palette.common.white} size={120} />
                  </IconButton>
                </div>
              </Grid>
            )}
          </Grid>
        )}
      </Container>

    </Page>
  );
}
